import PublicAppVars from "utils/PublicAppVars.js";
import React from "react";
import LatestEulaOfFeature from "pages/eula/LatestEulaOfFeature.js";

const TermsOfService = ({}) => <LatestEulaOfFeature feature={PublicAppVars.EULA_TOS} />;
export default TermsOfService;
